<template>
  <button
    class="fast-close flex h-[3rem] w-[3rem] min-w-[3rem] items-center justify-center rounded-full border-0 border-gray-200 text-2xl text-black p-0"
    @click="close"
  >
    <fa-icon type="fal" icon="times" />
  </button>
</template>

<script>
import { mapStores } from 'pinia'
import { STEPS, useMainStore } from '@/apps/fast/store'

export default {
  computed: {
    ...mapStores(useMainStore)
  },
  methods: {
    close() {
      if (this.mainStore.alert || [STEPS.name, STEPS.options].includes(this.mainStore.step)) this.$root.close()
      else this.mainStore.closeConfirmation = true
    }
  }
}
</script>
